import { useRouter, usePathname } from 'next/navigation';
import stateFilterStore from '@/stores/stateFilterStore';

export const useBackNavigation = () => {
  const router = useRouter();
  const pathname = usePathname();

  const goBack = () => {
    if (
      !pathname.includes('/filter') ||
      (pathname.includes('/filter') && !stateFilterStore.hideFilter)
    ) {
      router.back();
    } else {
      stateFilterStore.setHideFilter(!stateFilterStore.hideFilter);
    }
  };

  return { goBack };
};
